//Our build process replaces the string '22.2.0' with the version number.
//So it will be available at runtime.
let version = '22.2.0';

let cdnAssetPath = localStorage.getItem('pdsCdnAssetPath') || 'https://assets.powerschool.com/pds/' + version;

export let versionAndPaths = {
  version: version,
  cdnAssetPath: cdnAssetPath
};
